// extracted by mini-css-extract-plugin
export var at = "CreateSrmCard-module--at--72481";
export var band = "CreateSrmCard-module--band--37927";
export var content = "CreateSrmCard-module--content--d8fd7";
export var group = "CreateSrmCard-module--group--63ed2";
export var info = "CreateSrmCard-module--info--9640f";
export var pricing = "CreateSrmCard-module--pricing--16740";
export var srmIcon = "CreateSrmCard-module--srmIcon--b050b";